<template>
    <div>
        <el-tabs :stretch="true" v-model="activeName" @tab-click="handleClick">
            <el-tab-pane label="外文" name="外語"></el-tab-pane>
            <el-tab-pane label="通識" name="素養"></el-tab-pane>
            <el-tab-pane label="體育" name="體育"></el-tab-pane>
            <el-tab-pane label="微積分" name="微積分"></el-tab-pane>
            <el-tab-pane label="物理" name="物理"></el-tab-pane>
            <el-tab-pane label="軍訓" name="軍訓"></el-tab-pane>
            <el-tab-pane label="系共同必修" name="共同必修"></el-tab-pane>
        </el-tabs>
        <el-button size="mini" @click="showSoonNotification"> 幫我排志願序！</el-button>
        <el-row>
            <el-col :span="24">
                <course-list-simplified
                        :present-courses="presentCourses"/>
            </el-col>
        </el-row>

    </div>
</template>
<script>
    import {findDupNameCourses} from "@/courseProcessor";
    import CourseListSimplified from "@/components/Element/CourseListSimplified";

    export default {
        name: 'draw-course-selection',
        components: {CourseListSimplified},
        data() {
            return {
                activeName: '素養'
            };
        }
        ,
        methods: {
            handleClick(tab, event) {
                console.log(tab, event);
            },
            showSoonNotification() {
                this.$alert('這項功能將分析同類所有課程的選上機率，用數學排出最佳選課志願序，選課不再像玩樂透，讓你選好課又選搶手課！', '將在選課期間開放', {
                    confirmButtonText: '9/7 開放',
                })
            }
        },
        computed: {
            presentCourses() {

                const userDepAlias = this.user.dep.substr(0, 2);
                var courses = this.allCoursesList
                const filterOptions = {
                    '外語': (c) => c.type.includes(this.activeName),
                    '素養': (c) => c.brief.includes(this.activeName) && !c.cname.includes('微積分'),
                    '體育': (c) => c.brief.includes(this.activeName),
                    '微積分': (c) => c.cname.includes('微積分'),
                    '物理': (c) => (c.cname === ('物理(一)') || c.cname === ('物理(一)榮譽班')) && c.type.includes('必修'),
                    '軍訓': (c) => c.brief.includes('軍訓'),
                    '共同必修': (c) => c.dep_cname.includes(this.activeName) || c.memo.includes(this.activeName) || c.dep_cname.includes(userDepAlias),
                }
                courses = courses.filter(filterOptions[this.activeName])
                if (this.activeName === '共同必修') {
                    courses = courses.filter((c) => !((c.cname === ('物理(一)') || c.cname === ('物理(一)榮譽班'))))
                    courses = courses.filter((c) => !(c.cname.includes('微積分')))
                    courses = courses.filter((c) => !(c.cname.includes('體育')))
                    courses = courses.filter((c) => (c.dep_cname.includes(userDepAlias)))
                    courses = findDupNameCourses(courses).dupCourses
                }

                return courses
            }
        },
    }
</script>
